import { api } from './api'
import { Family, FamilyMember } from '../types/patientRelationship'
import { Patient } from '../types/patient'

export const familyService = {
  /**
   * Get all families
   */
  getAll: async (): Promise<Family[]> => {
    const response = await api.get<Family[]>('/families')
    return response.data
  },

  /**
   * Get a family by ID
   */
  getById: async (id: string): Promise<Family> => {
    const response = await api.get<Family>(`/families/${id}`)
    return response.data
  },

  /**
   * Get family members with full patient details
   */
  getMembers: async (familyId: string): Promise<FamilyMember[]> => {
    const response = await api.get<FamilyMember[]>(`/families/${familyId}/members`)
    return response.data
  },

  /**
   * Create a new family
   */
  create: async (data: Partial<Family>): Promise<Family> => {
    const response = await api.post<Family>('/families', data)
    return response.data
  },

  /**
   * Update a family
   */
  update: async (id: string, data: Partial<Family>): Promise<Family> => {
    const response = await api.put<Family>(`/families/${id}`, data)
    return response.data
  },

  /**
   * Delete a family
   */
  delete: async (id: string): Promise<void> => {
    await api.delete(`/families/${id}`)
  },

  /**
   * Add a patient to a family
   */
  addMember: async (familyId: string, patientId: string): Promise<void> => {
    await api.post(`/families/${familyId}/members`, { patientId })
  },

  /**
   * Remove a patient from a family
   */
  removeMember: async (familyId: string, patientId: string): Promise<void> => {
    await api.delete(`/families/${familyId}/members/${patientId}`)
  },

  /**
   * Search patients to add to family (excludes existing members)
   */
  searchPatientsForFamily: async (familyId: string, searchTerm: string): Promise<Patient[]> => {
    const response = await api.get<Patient[]>(`/families/${familyId}/search-patients`, {
      params: { q: searchTerm },
    })
    return response.data
  },
}



































